module.exports = new __parcel__URL__("enhancedpower.ab4ffa3e.png").toString();